import React, { useState, useEffect, useMemo } from 'react'
import { PencilIcon, CheckIcon } from '@heroicons/react/outline';
import Layout from './../../components/Layout/Layout';
import InvestmentServices from './../../services/InvestmentServices';
import { FormatMoney, FormatDollar } from './../../utils/formatMoney';
import fire from './../../utils/Toastr';



export default function Rates() {
    const data = {
        id: 0,
        rate: 0,
        minimumAmount: 0,
        maximumAmount: 0,
        tenure: ""
    }
    const [rate, setRate] = useState([])
    const [rateVale, setRateValue] = useState("")
    const [search, setSearch] = useState("")
    const [newRate, setNew] = useState(0)
    const [formValue, setFormValues] = useState(data)

    const update = async (rate) => {
        const data = {
            id: rate,
            rate: newRate,
            minimumAmount: 0,
            maximumAmount: 0,
            tenure: ""
        }
        const resp = await InvestmentServices.updateInvestment(data);
        if (resp) {
            setTimeout(() => {
                fire("success", resp.message);
            }, 2000);
        }
        window.location.reload();
    }
    const handleRate = async (e) => {
        setNew(e)
        setFormValues({ ...formValue, rate: newRate })
    }
    const edit = async (rate) => {
        setRateValue(rate)
    }
    const list = async () => {
        const resp = await InvestmentServices.listRates(search);
        setRate([...resp.data])
    }

    useEffect(() => {
        list();
    }, [])

    const groups = useMemo(() => {
        const map = new Map();
        rate.forEach((row) => {
            if (!map.has(row.investmentTypeId)) {
                map.set(row.investmentTypeId, {
                    id: row.investmentTypeId,
                    name: row.investmentTypeName,
                    category: row.investmentCategoryName,
                    rows: []
                });
            }
            map.get(row.investmentTypeId).rows.push(row);
        });
        return [...map.values()];
    }, [rate]);

    const isUsd = (group) => /usd/i.test(`${group.name} ${group.category}`);

    const formatAmount = (group, amount) => isUsd(group) ? FormatDollar(amount) : FormatMoney(amount);

    return (<>
        <Layout title="Rates Guide" pageTag={"investment"} current={'/investments/rates'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="px-4 sm:px-6 lg:px-8">
                            {rate.length === 0 ? (
                                <div className="mt-8"> No data available for these dates to show. </div>
                            ) : (
                                groups.map((group) => (
                                    <div key={group.id} className="mt-8">
                                        <div className="sm:flex sm:items-center">
                                            <div className="sm:flex-auto flex">
                                                <p>Investment Rate Guide – {group.name}</p>
                                            </div>
                                        </div>
                                        <div className="mt-8 flex flex-col">
                                            <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                                    <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" className="min-w-[14rem] pl-3 py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                                        {isUsd(group) ? "Minimum Amount (USD)" : "Minimum Amount (Naira)"}
                                                                    </th>
                                                                    <th scope="col" className="min-w-[14rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                                        {isUsd(group) ? "Maximum Amount (USD)" : "Maximum Amount (Naira)"}
                                                                    </th>
                                                                    <th scope="col" className="min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                                        Rate
                                                                    </th>
                                                                    <th scope="col" className="min-w-[6rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                                        Tenure
                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                                        <span className="sr-only">Edit</span>
                                                                    </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                                {group.rows.map((person, i) => (
                                                                    <tr key={i} className="bg-gray-50">
                                                                        <td className="pl-4 whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatAmount(group, person.minimumAmount)}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.isInfinity === true ? "Infinity" : formatAmount(group, person.maximumAmount)}</td>
                                                                        {rateVale !== person.id ?
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.rate}</td> :
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                                <input
                                                                                    type="text"
                                                                                    name="rate"
                                                                                    placeholder={person.rate}
                                                                                    onChange={(e) => handleRate(e.target.value)}
                                                                                />
                                                                            </td>
                                                                        }
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.tenure}</td>
                                                                        {rateVale !== person.id ?
                                                                            <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                                <button onClick={() => edit(person.id)}>
                                                                                    <PencilIcon className="w-4" />
                                                                                </button>
                                                                            </td> :
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                                <button
                                                                                    onClick={() => update(person.id)}>
                                                                                    <CheckIcon className='w-8' />
                                                                                </button>
                                                                            </td>
                                                                        }
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </main>
            </React.Fragment>
        </Layout>

    </>);
}